__turbopack_context__.v({
  "notifications-dropdown": "JczwdW_notifications-dropdown",
  "notifications-dropdown__card": "JczwdW_notifications-dropdown__card",
  "notifications-dropdown__content": "JczwdW_notifications-dropdown__content",
  "notifications-dropdown__header": "JczwdW_notifications-dropdown__header",
  "notifications-dropdown__header-actions": "JczwdW_notifications-dropdown__header-actions",
  "notifications-dropdown__panel": "JczwdW_notifications-dropdown__panel",
  "slide-in": "JczwdW_slide-in",
  "slide-out": "JczwdW_slide-out",
});
